import { APIUtils, Config } from '@vm/omega-shared-component-webapp';

import { APIResponse } from './types';

export const constructGetMiReportApiUrl = () => `${Config.get('microservice_base_url_api')}${Config.get('endpoints.post_mi_report')}`;

type MiReportApiRequestBody = {
  productId: string;
  status: 'STARTED';
  clientName: string;
};

type MiReportApiResponseBody = {
  transactionId: string;
  // More properties we do not need
};

export const postMiReport = async (productId: string, clientId: string): Promise<APIResponse<MiReportApiResponseBody>> => {
  const body: MiReportApiRequestBody = {
    productId,
    status: 'STARTED',
    clientName: clientId,
  };
  return APIUtils.withAuth(({ headers }) =>
    fetch(constructGetMiReportApiUrl(), {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    }),
  );
};
